import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const datetimeInputV4Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Datetime Input element to v4 by migrating default values to new format',
  run: (props: PartialPropsOf<'datetimeInput'>): void => {
    if (props?.content?.time?.defaultTime) {
      props.content = {
        ...props.content,
        time: {
          ...props.content?.time,
          defaultValue: 'other',
          defaultValueFunction: 'custom',
        },
      };
    }
  },
};
